module.exports = __webpack_public_path__ + "img/reporting-preview-1@2x.b1231510.png";